export default __webpack_public_path__ + "static/media/background-image-login-doctor.3b9d53a8.jpg";